import { GridStack } from "gridstack";
import DMSHeader from "../DMSHeader/DMSHeader";
import GridItem from "../../../Components/UiComponents/GridItem/GridItem";
import { useEffect } from "react";
import DeviationRoute from "./DeviationRoute";

const DeviationRouteHeader = () => {
  useEffect(() => {
    GridStack.init();
  }, []);

  const layoutData = [
    {
      x: 0,
      y: 0,
      width: 12,
      height: 1,
      id: 0,
      component: (
        <DMSHeader
          title="Deviation Route"
          showdownload={false}
          fileName="Deviation Route Details"
          showIconsForback={true}
        />
      ),
      haveOverflowVisible: true,
    },
    {
      x: 0,
      y: 1,
      width: 12,
      height: 13,
      id: 1,
      component: <DeviationRoute />,
    },
  ];

  return (
    <div className="grid-stack grid-stack-instance-1 smartpole__header--transition ">
      <GridItem layoutData={layoutData} />
    </div>
  );
};

export default DeviationRouteHeader;
